<template>
  <div class="home">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <!-- <keep-alive>
            <router-view></router-view>
        </keep-alive> -->
    <!-- <img src="../static/home/banner.png" alt="" style="width:100%;height:auto;"> -->
    <banner></banner>
    <!-- 服务人数 -->
    <serve-num></serve-num>
    <!-- 政策 -->
    <policy />
    <!-- 学习中心 -->
    <div class="learn">
      <div style="width: 1200px; margin: 0 auto">
        <div style="width: 100%; height: 50px"></div>
        <div style="
            line-height: 26px;
            font-size: 26px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #000000;
          ">
          学习中心<span style="
              line-height: 18px;
              font-size: 18px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
              margin-left: 10px;
            ">Learning&nbsp;Center</span>
        </div>
        <div style="
            width: 54px;
            height: 2px;
            background: #3476c1;
            margin-top: 20px;
          "></div>
        <div style="width: 100%; height: 30px"></div>
        <div>
          <div style="width: 325px; height: 518px; float: left">
            <el-carousel height="518px" indicator-position="none" arrow="never">
              <el-carousel-item>
                <a href="https://muke.jycyfww.com" target="_blank" style="display: block; width: 325px; height: 518px">
                  <img class="hover" src="../static/home/l_muke.png" alt="" style="width: 325px; height: 518px" />
                </a>
              </el-carousel-item>
              <el-carousel-item>
                <a href="https://muke.jycyfww.com" target="_blank" style="display: block; width: 325px; height: 518px">
                  <img src="../static/home/1_muke.png" alt="" style="width: 325px; height: 518px" />
                </a>
              </el-carousel-item>
              <el-carousel-item>
                <a href="https://ceping.jycyfww.com" target="_blank"
                  style="display: block; width: 325px; height: 518px">
                  <img src="../static/home/2_muke.png" alt="" style="width: 325px; height: 518px" />
                </a>
              </el-carousel-item>
              <el-carousel-item>
                <a href="https://busion.jycyfww.com" target="_blank"
                  style="display: block; width: 325px; height: 518px">
                  <img src="../static/home/3muke.png" alt="" style="width: 325px; height: 518px" />
                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="learn-i" @click="toOther(1)">
            <img src="../static/home/l_cxjycypj.png" alt="" style="display: block; width: 100%" />
            <div class="learn-i-txt">创新就业创业测评</div>
            <div class="learn-i-shade">创新就业创业测评</div>
          </div>
          <div class="learn-i" @click="toOther(2)">
            <img src="../static/home/l_ktzx.png" alt="" style="display: block; width: 100%" />
            <div class="learn-i-txt">课堂在线</div>
            <div class="learn-i-shade">课堂在线</div>
          </div>
          <div class="learn-i" @click="toOther(3)">
            <img src="../static/home/l_wlcysx.png" alt="" style="display: block; width: 100%" />
            <div class="learn-i-txt">网络创业实训</div>
            <div class="learn-i-shade">网络创业实训</div>
          </div>
          <div class="learn-i" @click="toOther(4)">
            <img src="../static/home/l_cymnsxt.png" alt="" style="display: block; width: 100%" />
            <div class="learn-i-txt">创业模拟实训（通用版）</div>
            <div class="learn-i-shade">创业模拟实训（通用版）</div>
          </div>
          <div class="learn-i" @click="toOther(5)">
            <img src="../static/home/l_cymnsxg.png" alt="" style="display: block; width: 100%" />
            <div class="learn-i-txt">创业模拟实训（网络版）</div>
            <div class="learn-i-shade">创业模拟实训（网络版）</div>
          </div>
          <div class="learn-i" @click="toMore('learn')">
            <img src="../static/home/more.png" alt="" style="display: block; width: 100%" />
            <div class="learn-i-txt">更多>></div>
            <div class="learn-i-shade">更多>></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 乡村振兴 -->
    <ruralVitalization />
    <!-- 活动 -->
    <activity></activity>
    <!-- 服务 -->
    <div style="background: #FFFFFF">
      <div class="serve">
        <div style="width: 100%; height: 50px"></div>
        <div style="font-family: MicrosoftYaHei; font-size: 26px; color: #000000">
          服务<span style="font-size: 18px; color: #666666; margin-left: 10px">Services</span>
        </div>
        <div style="
            width: 55px;
            height: 2px;
            background: #3476c1;
            margin-top: 20px;
            margin-bottom: 30px;
          "></div>
        <div style="display: flex; justify-content: space-between">
          <div class="serveritem" style="" @click="toServeList(item.id, item.name, item.englishName)"
            v-for="(item, index) in serveList" :key="index" @mouseover="mouseover(index)"
            @mouseleave="mouseleave(index)">
            <div class="serve-i-t1">
              <div :class="[index > -1 ? 'serve-i-t' + index + '' : '']">
                <div v-if="hoverindex != index" style="width: 82px; height: 82px; margin: 0 auto">
                  <img :src="item.coverImg1" alt="" class="serve-i-img" />
                </div>
                <div v-else style="width: 82px; height: 82px; margin: 0 auto">
                  <img :src="item.coverImg" alt="" class="serve-i-img" />
                </div>
                <div class="item-title" style="
                    width: 100%;
                    height: 22px;
                    line-height: 22px;
                    text-align: center;
                    font-size: 24px;
                    font-family: MicrosoftYaHei;
                    font-weight: 400;

                    margin-top: 45px;
                  ">
                  {{ item.name }}
                </div>
              </div>
              <div class="item-title" style="
                  width: 100%;
                  text-align: center;
                  height: 12px;
                  line-height: 12px;
                  font-size: 12px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;

                  margin-top: 19px;
                ">
                {{ item.englishName.toUpperCase() }}
              </div>
            </div>
          </div>
        </div>
        <div class="morezanserve" @click="tomoreserve">更多服务</div>
      </div>
    </div>
    <!-- 项目库 -->
    <project></project>

    <!-- 专家库 -->
    <expert></expert>
    <div id="thediv" ref="thediv" style="
        position: absolute;
        z-index: 1999;
        left: 0;
        top: 0;
        text-align: center;
        width: 180px;
      " v-show="thedivShow" @mouseover="clearFdAd" @mouseout="starFdAd">
      <div id="thedivone">
        <div style="
          text-align: right;
          font-size: 12px;
          color: #999999;
          position: absolute;
          right: 0px;
        ">
          <img @click="thedivShow = false" style="
           cursor: pointer;
            width: 13px;
            height: 13px;
            float: right;
            margin-top: 82px;
            margin-right: 13px;
          " src="../static/home/cuo.png" alt="" />
        </div>
        <a href="https://jycyfww.com/#/policyDetail?id=541;thedivShow = false" target="_blank"><img
            src="../static/home/pcbody.png" style="
            width: 160px;
            height: 57px;
            margin-left: 8px;
            margin-top: 104px;
          " /></a>
      </div>
      <div id="thedivtwo" v-show="theDivTwo" v-if="courseList.length != 0">
        <a :href="'https://muke.jycyfww.com/#/videolist?courseId=' + courseList[0].id" target="_blank">
          <div class="headImg">
            <img src="../static/home/thedivTwoTitle.png" alt="">
          </div>
          <div class="headtitle">
            {{ courseList[0].courseName }}
          </div>
        </a>
        <img @click="theDivTwo = false" src="../static/home/cuo.png" alt="" class="divtowcuo">
      </div>
      <div id="thedivthree" v-show="theDivThree">
        <a href="javascript:return false">
          <div class="headtitle">课程计划</div>
          <div class="bottomtitle">持续精彩</div>
        </a>
        <img @click="theDivThree = false" src="../static/home/cuo.png" alt="" class="divtowcuo">
      </div>
    </div>
  </div>
</template>

<script>
var interval;
import navigation from "@/components/common/navigation";
import banner from "@/components/home/banner.vue";
import policy from "@/components/home/policy.vue";
import expert from "@/components/home/expert.vue";
import activity from "@/components/home/activity.vue";
import project from "@/components/home/project.vue";
import ServeNum from "@/components/home/serve-num.vue";
import ruralVitalization from "@/components/home/ruralVitalization.vue";

export default {
  name: "home",
  components: {
    policy,
    navigation,
    banner,
    expert,
    activity,
    project,
    ServeNum,
    ruralVitalization
  },
  data() {
    return {
      theDivTwo: true,
      theDivThree: true,
      hoverindex: null,
      expertIndex: 0, //专家库
      expertList: [
        {
          img: "http://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/dev/82e39d089495456cb6b8a1fd6f7af39d.jpeg",
          title: "专家二号",
          introduce:
            "龚鹏程，享誉海内外的著名学者、教育家。大学时代即开始在各大学术杂志发表论文，迄今已出版专着八十余种（在大陆已出版三十五种），代",
        },
        {
          img: "http://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/dev/82e39d089495456cb6b8a1fd6f7af39d.jpeg",
          title: "专家三号",
          introduce: "文字文字文字文字",
        },
      ],
      sum: 0, //总人数
      serveList: [], //服务列表
      flag: true,
      tokenVal: "",
      tabIndexVal: 1,
      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 18,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,
      courseList: []
    };
  },

  methods: {
    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      this.$nextTick(() => {
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth;
      });

      // 滚动部分跟随屏幕滚动
      this.$refs.thediv.style.left =
        this.xPos +
        document.body.scrollLeft +
        document.documentElement.scrollLeft +
        "px";
      this.$refs.thediv.style.top =
        this.yPos +
        document.body.scrollTop +
        document.documentElement.scrollTop +
        "px";

      // 滚动部分不随屏幕滚动
      // this.$refs.thediv.style.left =
      //   this.xPos + document.body.scrollLeft + "px";
      // this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

      if (this.yon) {
        this.yPos = this.yPos + this.step;
      } else {
        this.yPos = this.yPos - this.step;
      }
      if (this.yPos < 0) {
        this.yon = 1;
        this.yPos = 0;
      }
      if (this.yPos >= height - this.Hoffset) {
        this.yon = 0;
        this.yPos = height - this.Hoffset;
      }

      if (this.xon) {
        this.xPos = this.xPos + this.step;
      } else {
        this.xPos = this.xPos - this.step;
      }
      if (this.xPos < 0) {
        this.xon = 1;
        this.xPos = 0;
      }
      if (this.xPos >= width - this.Woffset) {
        this.xon = 0;
        this.xPos = width - this.Woffset;
      }
    },
    clearFdAd() {
      clearInterval(interval);
    },
    starFdAd() {
      interval = setInterval(this.changePos, this.delay);
    },
    tomoreserve() {
      sessionStorage.setItem("tabIndex", 4);
      this.$router.push("/serve");
    },
    mouseover(index) {
      this.hoverindex = index;
    },
    mouseleave(index) {
      this.hoverindex = null;
    },




    expertItemFn(s) {
      this.expertIndex = s;
    },
    toServe(name) {
      sessionStorage.setItem("tabIndex", 4);
      // this.$router.push({
      //     path: '/serve',
      //     query: {
      //         name,
      //     }
      // })
    },
    toServeList(id, catalogueName, catalogueEnglishName) {
      sessionStorage.setItem("tabIndex", 4);
      this.$router.push({
        path: "/serveList",
        query: {
          id,
          catalogueName,
          catalogueEnglishName,
        },
      });
    },
    //更多按钮
    toMore(type) {
      if (type === "policy") {
        sessionStorage.setItem("tabIndex", 2);
        this.$router.push("/policy");
      } else if (type === "learn") {
        sessionStorage.setItem("tabIndex", 3);
        this.$router.push("/learn");
      } else if (type === "serve") {
        sessionStorage.setItem("tabIndex", 4);
        this.$router.push("/serve");
      } else if (type === "activity") {
        sessionStorage.setItem("tabIndex", 5);
        this.$router.push("/activity");
      } else if (type === "expert") {
        sessionStorage.setItem("tabIndex", 6);
        this.$router.push("/expert");
      } else if (type === "project") {
        sessionStorage.setItem("tabIndex", 7);
        this.$router.push("/project");
      }
    },
    //详情跳转
    toDetail(type) {
      if (type === "policy") {
        sessionStorage.setItem("tabIndex", 2);
        this.$router.push("/policy");
      } else if (type === "learn") {
        sessionStorage.setItem("tabIndex", 3);
        this.$router.push("/learn");
      } else if (type === "serve") {
        sessionStorage.setItem("tabIndex", 4);
        this.$router.push("/serve");
      } else if (type === "activity") {
        sessionStorage.setItem("tabIndex", 5);
        this.$router.push("/activity");
      } else if (type === "expert") {
        sessionStorage.setItem("tabIndex", 6);
        this.$router.push("/expert");
      } else if (type === "project") {
        sessionStorage.setItem("tabIndex", 7);
        this.$router.push("/project");
      }
    },
    toOther(s) {
      if (s === 1) {
        //测评
        window.open("http://ceping.jycyfww.com/", "_blank");
      } else if (s === 2) {
        //慕课
        window.open("https://muke.jycyfww.com", "_blank");
      } else if (s === 3) {
        // 网创
        window.open("https://wangchuang.jycyfww.com", "_blank");
      } else if (s === 4) {
        // 模拟实训 通用版
        window.open("https://busion.jycyfww.com", "_blank");
      } else if (s === 5) {
        // 模拟实训 个人版
        window.open("http://www.qcwlcloud.com:8900/busion/", "_blank");
      }
    },
    // 请求最新慕课课程
    getNewMuke() {
      this.$axios.get('/v1/cloud/common/course/new').then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.courseList = res.data.data
        }
      })
    },
  },
  created() {
    this.getNewMuke()
 
   

    //服务
    this.$axios
      .get("/v1/cloud/common/services/catalogue")
      .then(({ data }) => {
        if (data) {
          this.serveList = data;
        }
      })
      .catch((error) => {
        this.$message.error(error.response.data.message);
      });
  },
  mounted() {
    interval = setInterval(this.changePos, this.delay);
  },
  destroyed() {
    clearInterval(interval);
  },
};
</script>

<style scoped lang="less">
img.hover:hover {
  transition: all 1s;
  transform: scale(1.2);
}

#thedivone {
  height: 191px;
  width: 180px;
  overflow: hidden;
  background-image: url("../static/home/pcbg.gif");
  background-size: 180px 191px;

  img {
    width: 100%;
    height: 100%;
  }
}

#thedivtwo {
  position: relative;

  a {
    position: relative;
    display: block;
    width: 172px;
    height: 110px;
    background-image: url('../static/home/thedivtwoBack.png');
    background-size: 172px 110px;
    padding-top: 14px;
    box-sizing: border-box;
    margin: -6px auto 0;
  }

  .headImg {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;

    img {
      width: 105px;
      height: 24px;
    }
  }

  .headtitle {
    margin: 10px auto 0;
    width: 156px;
    font-family: 'jijiachaojihei';
    font-size: 15px;
    font-weight: 400;
    color: #FF9A4F;
    line-height: 20px;
  }

  .divtowcuo {
    position: absolute;
    top: 10px;
    right: 13px;
    width: 13px;
    height: 13px;
    cursor: pointer;
    z-index: 888;
  }
}

#thedivthree {
  position: relative;

  a {
    position: relative;
    display: block;
    width: 172px;
    height: 110px;
    background-image: url('../static/home/thedivThreeBack.png');
    background-size: 172px 110px;
    padding-top: 14px;
    box-sizing: border-box;
    margin: 0 auto;

    .headtitle {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-style: italic;
      color: #FFFFFF;
      text-shadow: 0px 0px 1px rgba(0, 126, 83, 0.55);
      text-align: left;
      margin-left: 36px;
      margin-top: 16px;
    }

    .bottomtitle {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-style: italic;
      color: #FFFFFF;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFAF57 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .divtowcuo {
    position: absolute;
    top: 10px;
    right: 13px;
    width: 13px;
    height: 13px;
    cursor: pointer;
    z-index: 888;
  }
}

.home {
  width: 100%;
  height: auto;

  // background:#f7f7f7;
  // -webkit-touch-callout: none; /* iOS Safari */
  // -webkit-user-select: none; /* Chrome/Safari/Opera */
  // -khtml-user-select: none; /* Konqueror */
  // -moz-user-select: none; /* Firefox */
  // -ms-user-select: none; /* Internet Explorer/Edge */
  // user-select: none;
  // 服务人数
  .more-btn {
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: rgba(0, 0, 0, 1);
    border-radius: 20px;
    margin: 0 auto;
    margin-top: 10px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .more-btn:hover {
    box-shadow: 0px 10px 30px 0px rgba(153, 153, 153, 0.5);
  }



  .learn {
    width: 100%;
    height: 694px;
    background: #f5f5f5;

    .learn-i {
      width: 272px;
      height: 249px;
      float: left;
      position: relative;
      cursor: pointer;
      margin-left: 19px;
      margin-bottom: 20px;

      .learn-i-shade {
        width: 272px;
        height: 249px;
        line-height: 249px;
        text-align: center;
        background: rgba(52, 118, 193, 0.8);
        opacity: 1;
        font-size: 22px;
        font-family: MicrosoftYaHei;
        position: absolute;
        top: 0;
        display: none;
        font-weight: bold;
        color: #ffffff;
      }

      .learn-i-txt {
        position: absolute;
        bottom: 0px;
        width: 272px;
        height: 40px;
        background: rgba(52, 118, 193, 0.6);
        opacity: 1;
        line-height: 40px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        text-indent: 10px;
      }
    }

    .learn-i:hover .learn-i-txt {
      display: none;
    }

    .learn-i:hover .learn-i-shade {
      display: block;
    }
  }

  .serve {
    width: 1200px;
    margin: 0 auto;
    height: 518px;
    background: #ffffff;
    box-sizing: border-box;

    .morezanserve {
      margin: 40px auto 0;
      width: 150px;
      height: 40px;
      border: 1px solid #5fc0e4;
      border-radius: 3px;
      line-height: 40px;
      color: #5fc0e4;
      box-sizing: border-box;
      text-indent: 34px;
      background-image: url("../static/common/morezan.png");
      background-size: 15px 15px;
      background-repeat: no-repeat;
      background-position: 101px 12px;
      cursor: pointer;
    }

    .morezanserve:hover {
      background-color: #5fc0e4;
      background-image: url("../static/common/morezan1.png");
      color: #fff;
    }

    .serveritem {
      width: 270px;
      cursor: pointer;
      height: 260px;
      background-color: #fff;
      padding-top: 51px;
      box-shadow: 0px 0px 15px 0px rgba(207, 206, 206, 0.4);
    }

    .serveritem:hover {
      background-color: #3476c1;
    }

    .serveritem:hover .item-title,
    .serveritem:hover .item-body {
      color: #fff;
    }

    .item-title {
      color: #333333;
    }

    .item-body {
      color: #999999;
    }

    .serve-i-t0 {
      width: 270px;

      // background:url(../static/home/gs.png);
      .serve-i-img {
        width: 82px;
        height: 82px;
      }
    }

    .serve-i-t1 {
      width: 270px;

      .serve-i-img {
        width: 82px;
        height: 82px;
      }
    }

    .serve-i-t2 {
      width: 270px;

      .serve-i-img {
        width: 82px;
        height: 82px;
      }
    }

    .serve-i-t3 {
      width: 270px;

      .serve-i-img {
        width: 82px;
        height: 82px;
      }
    }
  }
}
</style>
